import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingCart = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 14.5C5.55228 14.5 6 14.0523 6 13.5C6 12.9477 5.55228 12.5 5 12.5C4.44772 12.5 4 12.9477 4 13.5C4 14.0523 4.44772 14.5 5 14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 14.5C12.0523 14.5 12.5 14.0523 12.5 13.5C12.5 12.9477 12.0523 12.5 11.5 12.5C10.9477 12.5 10.5 12.9477 10.5 13.5C10.5 14.0523 10.9477 14.5 11.5 14.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.64375 4.5H13.8562L12.2063 10.275C12.1474 10.4846 12.0213 10.669 11.8474 10.8C11.6735 10.931 11.4614 11.0013 11.2437 11H5.25625C5.03855 11.0013 4.82647 10.931 4.65258 10.8C4.47869 10.669 4.35262 10.4846 4.29375 10.275L2.03125 2.3625C2.00135 2.25797 1.9382 2.16604 1.85136 2.10062C1.76452 2.03521 1.65872 1.99989 1.55 2H0.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgShoppingCart;
